import { css } from '@backyard-ui/styles';

const ColStyles = css({
  position: 'relative',
  flexBasis: '$$size',
  flexShrink: 0,
  maxWidth: '$$size',
  boxSizing: 'border-box',
  variants: {
    gutter: {
      xs: {
        paddingX: 'calc($1 / 2)',
      },
      sm: {
        paddingX: 'calc($2 / 2)',
      },
      md: {
        paddingX: 'calc($3 / 2)',
      },
      lg: {
        paddingX: 'calc($4 / 2)',
      },
      xl: {
        paddingX: 'calc($5 / 2)',
      },
    },
    noGutters: {
      true: {
        paddingX: 0,
      },
    },
    isGrow: {
      true: {
        flexGrow: 1,
        maxWidth: 'unset',
      },
    },
  },
  defaultVariants: {
    gutter: 'lg',
    noGutters: false,
    isGrow: false,
  },
});

export default ColStyles;
